import request from '@/utils/request'

export function getTuan(params) {
    return request({
        url: '/index/tuan',
        method: 'get',
        params
    })
}